<template>
  <article class="">
    <cabeceraEN></cabeceraEN>
     <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>Public Offering</h2>
    </section>
    <section class="descripcion">
      <div class="container">
        <div class="caja">
          <p>
            COMPAÑÍA MEGA S.A. entered the CNV’s Public Offering Regime under
            resolution RESFC-2019-20543-APN-DIR#CNV dated November 7, 2019.
            For more information on the company and the capital market, you can visit the
            official web <a target="_blank" href="https://www.cnv.gov.ar/SitioWeb/Empresas"> site of the CNV</a> (Argentina’s National Securities Commission for its Spanish acronym) (*)
          </p>
          <p><i>(*) This is a link to the CNV’s web site. The CNV is not part of this Company, therefore, (agregar Compañía, en castellano tambien) Compañia Mega S.A. is not responsible for the accuracy of the information included therein or for supplementing, updating or correcting said information.</i></p>        
        </div>
      </div>
      
    </section>
    <pieEN></pieEN>
  </article>
</template>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
.btn-ar
    display: flex
    justify-content: center
    border: solid 1px #444
    margin-top: 30px
    width: 300px
    padding: 5px
    border-radius: 0px
    // &:hover
    // background-color: #004D9E
    &:hover
      background-color: #004D9E
      border-color: #fff
      a h5
        color: #fff
a h5
  font-size: 18px
  margin: 0
  display: inline-block
  color: black
  &:hover
    color: #fff
p
  padding-top: 30px
  padding-left: 10px
  padding-right: 10px
  a
    color: #004D9E
i
  font-size: 16px
  opacity: 0.8
.caja
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
.caja
  text-align: center
  p
    font-size: 18px

  /* Global Styles */


</style>

<script>
export default {
  name: 'regimen',
  components: {
    CabeceraEN,
    PieEN
  }
}
import CabeceraEN from '@/components/CabeceraEN'
import PieEN from '@/components/PieEN'
import $ from 'jquery'
$(document).ready(function () {
  $('.btn').click(function () {
    $(this).toggleClass('active')
    $('.profile .box').toggleClass('open')
  })
})
</script>





// WEBPACK FOOTER //
// src/components/regimen-en/regimen-en.vue